module.exports = __webpack_public_path__ + "static/media/1.617b9ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/perks/1.png
// module id = 57
// module chunks = 0